import { render, staticRenderFns } from "./sendServiceEmail.vue?vue&type=template&id=4356c8e8&scoped=true&"
import script from "./sendServiceEmail.vue?vue&type=script&lang=js&"
export * from "./sendServiceEmail.vue?vue&type=script&lang=js&"
import style0 from "./sendServiceEmail.vue?vue&type=style&index=0&id=4356c8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356c8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4356c8e8')) {
      api.createRecord('4356c8e8', component.options)
    } else {
      api.reload('4356c8e8', component.options)
    }
    module.hot.accept("./sendServiceEmail.vue?vue&type=template&id=4356c8e8&scoped=true&", function () {
      api.rerender('4356c8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/sendServiceEmail.vue"
export default component.exports